import { CustomerLinkButton } from "../../shared/CustomerControls";
import {
  CustomerContentRail,
  CustomerPageCanvas,
  CustomerSectionBand,
} from "../../shared/CustomerLayout";
import { Icon } from "../../shared/Icon";
import "./policy-system.css";

export default function NotFoundPage() {
  return (
    <CustomerPageCanvas className="lc-system-not-found">
      <CustomerSectionBand tone="canvas" spacing="generous">
        <CustomerContentRail width="reading">
          <section className="lc-system-not-found__card" aria-labelledby="not-found-title">
            <span className="lc-system-not-found__folio" aria-hidden="true">
              404
            </span>
            <span className="lc-system-not-found__icon" aria-hidden="true">
              <Icon name="book" size={32} />
            </span>
            <h1 id="not-found-title">
              This page slipped <em>out of the story.</em>
            </h1>
            <p>The link may have changed, but your private books have not.</p>
            <CustomerLinkButton
              tone="primary"
              size="large"
              to="/books"
              iconAfter={<Icon name="arrow" />}
            >
              Explore the books
            </CustomerLinkButton>
          </section>
        </CustomerContentRail>
      </CustomerSectionBand>
    </CustomerPageCanvas>
  );
}
